import React, { useEffect, useState, useRef, useContext } from 'react'
import _ from "lodash"
import moment from "moment"
import { useTranslation } from 'react-i18next'

import useFetchStatus from "customHooks/useFetchStatus"
import CustomTable from "../components/ReactTable"
import TitleWithBtn from "../components/Titles/TitleWithBtn"
import Requests from 'main_views/form/request'
import { errorToast, deleteAlert, successToast } from "../components/toast"
import { updateDoc, getTicketStep, getTicketStep2, handleTicket, addDate } from "../Tasks/handler"
import StatusFilter from "main_views/components/Filter/status"
import { filterItems } from "utils/helper"
import { UserContext } from "context/auth";
import PreviewModal from "main_views/Tasks/previewModal"

const intiPagination = { orderBy: 'number' }

function Home() {

    let { t } = useTranslation()
    let { user: currentUser } = useContext(UserContext)

    /* Note: 
    ** Home for staff **:  Staff = all tickets requestedBy == staff id
    ** Home for manager ** : Manager = all tickets requestedBy == staff id
    */
    let staffIdQuery = [
        { field: "requestedBy", value: currentUser.id },
        { field: "inProgress", value: true }
    ]
    let [updateList, setUpdateList] = useState(0)

    let [pagination, setPagination] = useState(intiPagination)
    let [tickets, ticketError, isTicketLoading] = useFetchStatus(`tickets`, {}, [updateList, currentUser.id, pagination], staffIdQuery, false, pagination)
    let [loadedTickets, setLoadedTickets] = useState([])

    let [staffs, staffsError, isStaffsLoading] = useFetchStatus(`staff`, {}, [], null)

    // preview Request Modal
    let [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false)
    let [previewingTicket, setPreviewTicket] = useState()

    let requestModalRef = useRef()

    // filter
    let [filteredItems, setFilteredItems] = useState()
    let [ticketList, setTicketList] = useState([])
    let [handeledTicketList, setHandeledTicketList] = useState([])
    let [isHandling, setHandling] = useState(false)

    useEffect(() => {
        setTicketList(_.values(tickets))
    }, [tickets])

    useEffect(() => {
        setHandling(true)
        Promise.resolve(handler(ticketList, staffs)).then(data => {
            setHandling(false)
            setHandeledTicketList(data)
        })
    }, [ticketList])

    // merge the new fetched data with table body data
    useEffect(() => {
        setLoadedTickets(_.concat(loadedTickets, _.values(ticketList)))
    }, [ticketList])

    let fetchMoreData = () => {
        let lastVisibleTicketNumber = _.last(_.values(ticketList)).number
        setPagination({ ...pagination, lastVisible: lastVisibleTicketNumber })
    }

    const deleteTicket = async (index) => {

        let ticket = filteredItems[index]
        // show delete confirmation alert
        let { value: wasConfirmed } = await deleteAlert()
        if (!wasConfirmed) return;
        else
            try {
                let docPath = `tickets/${ticket.id}`
                let ticket_updateData = { inProgress: false, wasCanceled: true, closedAt: moment().format('YYYY-MM-DD HH:mm:ss') }
                console.log(ticket_updateData)

                // to set next ticket step
                await getTicketStep(ticket_updateData, _.values(staffs))

                // save the updates & update the counter
                let increment = window.firebaseIncrement

                await Promise.all([
                    updateDoc(ticket_updateData, docPath),
                    updateDoc({ canceled: increment }, 'counter/tickets')
                ])

                successToast(t('request_was_canceled'))
                updateTicketsList()

            } catch (error) {
                console.log(error)
                errorToast(t('something_wrong'))
            }

    }

    const previewTicket = (index) => {
        setPreviewTicket(filteredItems[index])
        setIsPreviewModalOpen(true)
    }

    const Header = [
        {
            Header: "#",
            accessor: "number",
            type: "string",
            sortable: true,
        },
        {
            Header: t('requester_name'),
            accessor: "requesterName",
            type: "string",
            sortable: true,
        },
        {
            Header: t('form_name'),
            accessor: "form.name",
            type: "string",
            sortable: true,
        },
        {
            Header: t('due_date'),
            accessor: "dueDate",
            type: "firestoreTime",
            sortable: true,
        },
        {
            Header: t('priority'),
            accessor: "priority",
            type: "priorityTxt",
            sortable: true,
        },
        {
            Header: t('step'),
            accessor: "step",
            type: "string",
            sortable: true,
        },
        {
            Header: t('open_at'),
            accessor: "openedAt",
            type: "firestoreTime",
        },
        {
            Header: t('date_and_time'),
            accessor: "date",
            type: "dateAndTime",
        },
        {
            Header: " ",
            buttonTitle: t('preivew'),
            type: "button",
            color: "info",
            isOutline: true,
            sortable: false,
            onClick: previewTicket,
        },
        {
            type: "button",
            buttonTitle: t('cancel'),
            color: "danger",
            isOutline: true,
            sortable: false,
            onClick: deleteTicket
        },
    ]

    let updateTicketsList = () => {
        setUpdateList(++updateList)
        setLoadedTickets([])
        setPagination(intiPagination)
    }

    return (
        <div className="content">

            <TitleWithBtn
                title={t('all_requests')}
                button={{
                    title: t('new_request'),
                    onClick: () => requestModalRef.current.toggleModal()
                }}
            />

            {/* requests list & froms modal */}
            <Requests ref={requestModalRef} updateTicketsList={updateTicketsList} />

            {/*Display Tickets list */}
            <CustomTable
                title={t('all_requests')}
                header={Header}
                loading={isTicketLoading || isHandling}
                body={loadedTickets}
                hasSearchBar={true}
                searchBarTitle={t('search')}
                setFilterResult={setFilteredItems}
                selectDateRangeBeforeExport={true}
                loadMoreBtn={{
                    onClick: fetchMoreData,
                    isDisabled: !isTicketLoading && _.isEmpty(tickets)
                }}
                dataQuery={staffIdQuery} // for search & export 
                dataHandler={(allTickets) => handler(allTickets, staffs)} // to handel the data after fetch
            />

            {/* Preview ticket modal */}
            {previewingTicket && (
                <PreviewModal
                    isOpen={isPreviewModalOpen}
                    toggle={() => setIsPreviewModalOpen(false)}
                    ticket={previewingTicket}
                    staffs={staffs}
                />
            )}

        </div>

    )
}

export default Home


async function handler(tickets, staffs) {

    let filteredTickets = await Promise.all(_.map(tickets, (ticket) => ticket = addDate(ticket)))

    filteredTickets = await getTicketStep2(filteredTickets, staffs)

    return filteredTickets

}

let getInfo = async (tickets) => {

    await Promise.all(_.map(tickets, async (ticket) => {
        ticket = await handleTicket(ticket)

    }))

    return tickets

}
